
import Refresh2 from "../../../assets/duotone/Refresh2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Refresh2Icon({ className, dataTestid = "Refresh2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Refresh2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
